import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
var __jsx = React.createElement;
import PlayerContainer from '@anm/components/PlayerContainer';
import Image from '@anm/components/image/Image';
import isInIframe from '@anm/helpers/is/isInIframe';
import noop from '@anm/helpers/noop';
import useResize from '@anm/hooks/useResize';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect, useRef } from 'react';
import { ContainerWrapper, Preview, Wrapper } from './Wrapper';
export { Wrapper };

var PlayerWrapper = function PlayerWrapper(_ref) {
  var startTime = _ref.startTime,
      videoName = _ref.videoName,
      previewSrc = _ref.previewSrc,
      playerSizes = _ref.playerSizes,
      playerWrapperRef = _ref.playerWrapperRef,
      _ref$onPlayerInit = _ref.onPlayerInit,
      onPlayerInit = _ref$onPlayerInit === void 0 ? noop : _ref$onPlayerInit,
      playerProps = _objectWithoutProperties(_ref, ["startTime", "videoName", "previewSrc", "playerSizes", "playerWrapperRef", "onPlayerInit"]);

  var _useSwitchState = useSwitchState(),
      _useSwitchState2 = _slicedToArray(_useSwitchState, 2),
      playerInited = _useSwitchState2[0],
      setPlayerInited = _useSwitchState2[1];

  var _useSwitchState3 = useSwitchState(),
      _useSwitchState4 = _slicedToArray(_useSwitchState3, 2),
      resized = _useSwitchState4[0],
      setResized = _useSwitchState4[1];

  var playerContainerRef = useRef(null);
  useResize(function () {
    return !isInIframe() && setResized();
  });
  var handlePlayerInit = useCallback(function () {
    onPlayerInit();
    setPlayerInited();
  }, [playerInited, onPlayerInit]);
  useEffect(function () {
    var _window$wavePlayer$in, _window$wavePlayer;

    if (!playerContainerRef.current || playerInited || !window.wavePlayer) {
      return;
    }

    (_window$wavePlayer$in = (_window$wavePlayer = window.wavePlayer).init) === null || _window$wavePlayer$in === void 0 ? void 0 : _window$wavePlayer$in.call(_window$wavePlayer, playerContainerRef.current);
  }, [playerContainerRef]);
  var manifest = playerProps.manifest;
  var canShowPreview = !startTime && previewSrc && !playerInited && !(manifest !== null && manifest !== void 0 && manifest.error) && !(manifest !== null && manifest !== void 0 && manifest.configs.autoplay);
  return __jsx(Wrapper, _extends({
    ref: playerWrapperRef,
    resized: resized,
    playerInited: playerInited
  }, playerSizes), canShowPreview && __jsx(Preview, null, __jsx(Image, {
    src: previewSrc,
    alt: videoName
  })), __jsx(ContainerWrapper, {
    isInited: playerInited
  }, __jsx(PlayerContainer, _extends({}, playerProps, {
    startTime: startTime,
    playerContainerRef: playerContainerRef,
    onPlayerInit: handlePlayerInit
  }))));
};

export default PlayerWrapper;